import { AppService } from '@app/app.service';
import { ChangeDetectionStrategy, Component, inject, OnInit, ViewChild } from '@angular/core';
import { defaultConfig, EmojiUrlFn } from '@components/emoji-picker/emoji-picker.interface';
import { EmojiData } from '@ctrl/ngx-emoji-mart/ngx-emoji';
import { EmojiPickerService } from '@components/emoji-picker/emoji-picker.service';
import { FieldConfig } from '../field.interface';
import { FormGroup } from '@angular/forms';
import { MatMenuTrigger } from '@angular/material/menu';

/**
 * Компонент для динамического поля выбора эмотикона.
 */
@Component({
    selector: 'app-emoji',
    templateUrl: './emoji.component.html',
    styleUrls: ['./emoji.component.scss', './../input/input.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmojiComponent implements OnInit {
    protected readonly appService = inject(AppService);
    private readonly emojiService = inject(EmojiPickerService);

    field: FieldConfig;
    group: FormGroup;
    data: { mask: string } = {
        mask: null,
    };
    emojiUrlFn: EmojiUrlFn = this.emojiService.getEmojiUrlFn(defaultConfig);

    @ViewChild('emojiPickerTrigger') emojiPickerTrigger: MatMenuTrigger;

    protected get hasEmoji() {
        return this.group.get(this.field.name).value ? true : false;
    }

    protected get currentEmojiUrl() {
        const currentValue = this.group.get(this.field.name).value;
        return this.emojiUrlFn(currentValue);
    }

    ngOnInit() {
        if (this.field.disabled) {
            setTimeout(() => {
                this.group.get(this.field.name).disable({ onlySelf: true, emitEvent: false });
            });
        }
    }

    /**
     * Установка запрета изменения поля
     * @param disabled значение флага
     */
    setDisabled(disabled) {
        this.field.disabled = disabled;
        if (this.field.disabled) {
            this.group.get(this.field.name).disable({ onlySelf: true, emitEvent: false });
        } else {
            this.group.get(this.field.name).enable({ onlySelf: true, emitEvent: false });
        }
    }

    emojiPicked(data: EmojiData) {
        this.group.get(this.field.name).setValue(data.unified);
        this.emojiPickerTrigger.closeMenu();
    }
}
